import Grid from '@mui/material/Grid';
import PropTypes, {shape} from 'prop-types';

import Button from '../../../form/buttons/Button/Button';

const ParametersActions = ({formState, onCancel, onSave}) => {
  const {isDirty, isValid, isSubmitting} = formState;

  return (
    <Grid container alignItems="center" gap={2} mt={2} justifyContent="flex-end">
      <Button variant="outlined" color="error" disabled={!isDirty || isSubmitting} onClick={onCancel}>
        Annuler
      </Button>

      <Button variant="contained" color="secondary" disabled={!isDirty || !isValid || isSubmitting} onClick={onSave}>
        Enregistrer
      </Button>
    </Grid>
  );
};

ParametersActions.propTypes = {
  formState: shape({
    isDirty: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default ParametersActions;
